/** Lightweight inline sparkline for table rows/KPI cells — ECharts is overkill at this density. */
export function Sparkline({
  data,
  color = '#4f46e5',
  width = 90,
  height = 22,
}: {
  data: number[]
  color?: string
  width?: number
  height?: number
}) {
  if (data.length < 2) return null
  const pad = 2
  const min = Math.min(...data)
  const max = Math.max(...data)
  const span = max - min || 1
  const stepX = (width - pad * 2) / (data.length - 1)
  const path = data
    .map((v, i) => {
      const x = pad + i * stepX
      const y = height - pad - ((v - min) / span) * (height - pad * 2)
      return `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')
  const last = data[data.length - 1]
  const lx = width - pad
  const ly = height - pad - ((last - min) / span) * (height - pad * 2)

  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} preserveAspectRatio="none">
      <path d={path} fill="none" stroke={color} strokeWidth={1.5} />
      <circle cx={lx} cy={ly} r={2} fill={color} />
    </svg>
  )
}
